import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { actionPatient } from "../../../redux/actions";
import { Commons } from "../../../utilities";
import { AppLayout } from "../../../layouts";
import { Header, SearchBars, Sides, Tabbles } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { PiBinoculars, PiCalendar, PiFolderOpen, PiTrash } from "react-icons/pi";
import { LuFileSearch2 } from "react-icons/lu";

const AppointmentCompleted = ({ loginData }) => {
    const { t } = useTranslation();
    const options = [
        { value: 1, label: t("OnLine") },
        { value: 2, label: t("InClinic") },
        { value: 3, label: t("Chat") },
    ];
    const dispatch = useDispatch();
    const [appointmentRequestData, setAppointmentRequestData] = useState([]);
    useEffect(() => {
        dispatch(
            actionPatient.getAppointments(
                10,
                1,
                "",
                "",
                "",
                loginData.userGuid,
                "",
                4,
                "",
                "",
                null,
                null,
                "EUR",
                loginData.timeZoneId,
                "",
                null,
                null,
                loginData?.languageId,
                [1, 2],
                null
            )
        );
    }, [
        dispatch,
        loginData.userGuid,
        loginData.clinicGuid,
        loginData.timeZoneId,
        loginData?.currencyCode,
        loginData?.languageId,
    ]);

    const getAppointmentsData = useSelector(
        (state) => state.patient.getAppointmentsData?.data
    );
    useEffect(() => {
        if (getAppointmentsData?.result?.patientAppointments) {
            setAppointmentRequestData(getAppointmentsData.result.patientAppointments);
        }
    }, [getAppointmentsData]);
    const startDate =
        appointmentRequestData?.length > 0
            ? Commons.formatDateWithOrdinal(
                new Date(appointmentRequestData[0].appointmentDateTime)
            )
            : "";

    const endDate =
        appointmentRequestData?.length > 0
            ? Commons.formatDateWithOrdinal(
                new Date(
                    appointmentRequestData[
                        appointmentRequestData.length - 1
                    ].appointmentDateTime
                )
            )
            : "";

    const rightSide = (
        <Container fluid className={`exado-container1 `}>
            <Row className="exado-row1">
                <Col>
                    {/* <Header.HeadingPage
                        pageHeading={t("appointments.requested.page-heading")}
                      /> */}
                    <Header.HeadingPage
                        pageHeading={t("appointments.completed.page-heading")}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <SearchBars.SearchBar
                        className="search-bar"
                        showDate={true}
                        showSelect1={true}
                        datepickermd={2}
                        selectColmd1={3}
                        searchColmd={5}
                        buttonColmd={2}
                        datepickerxs={6}
                        selectColxs1={6}
                        selectColxs={6}
                        buttonColxs={12}
                        searchGrpClassName="form-group1"
                        select1Classname="select3"
                        select1Options={options}
                        searchPlaceholder={t("Search")}
                        select1Placeholder={t("location")}
                        cDateRangePlaceholder={t("enter") + " " + t("date")}
                        cDateRangeClassname="custom-date-range-picker"
                        buttonClassname="btn-solid-Aqua_Teal w-100"
                        buttonChildren={<PiBinoculars className="bionCularIcon" />}
                    // dateRange={dateRange}
                    // searchValue={search}
                    // select1Value={selectedLocation}
                    // select2Value={selectedClinic}
                    // onDateRangeChange={handleDateRangeChange}
                    // onSearchClick={() => onSearchClick(activeTab)}
                    // onLocationChange={(selected) => handleChange("location", selected)}
                    // onClinicChange={(selected) => handleChange("clinic", selected)}
                    // onSearchChange={(e) => handleChange("search", e.target.value)}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <Tabbles.TableBlk
                        headerIcon={<PiCalendar className="header-Icn" />}
                        heading={t("appointments.completed.page-heading")}
                        subHeading={
                            <span>
                                {t("From")}, {startDate} - {endDate}
                            </span>
                        }
                        columns={[
                            `${t("booking_id")}`,
                            `${t("clinics_name")}`,
                            `${t("doctor_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("time_&_date")}`,
                            `${t("location")}`,
                            `${t("Diagnosis")}`,
                            "EUR",

                        ]}
                        data={appointmentRequestData?.map((appointment) => ({
                            [t("booking_id")]: appointment.bookingId,
                            [t("clinics_name")]: appointment.clinicName,
                            [t("doctor_name")]:
                                appointment.doctorFirstName + " " + appointment.doctorLastName,
                            [t("medical_specialty")]: appointment.physicianServices,
                            [t("time_&_date")]: (
                                <>
                                    <div>
                                        {new Date(
                                            appointment.appointmentDateTime
                                        ).toLocaleTimeString("en-US", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </div>
                                    <div>
                                        {new Date(appointment.appointmentDateTime)
                                            .toLocaleDateString("en-GB")
                                            .replace(/\//g, " - ")}
                                    </div>
                                </>
                            ),
                            [t("location")]: appointment.appointmentType,
                            [t("Diagnosis")]: (
                                <div className="editBlkIcon">
                                    <LuFileSearch2
                                        //   onClick={() =>
                                        //     navigate(
                                        //       `/doctor/diagnostic-report/patient-information-and-symptoms`,
                                        //       {
                                        //         state: {
                                        //           appointment,
                                        //           appointmentStatus: 4,
                                        //         },
                                        //       }
                                        //     )
                                        //   }
                                        className="editIcon"
                                    />
                                </div>
                            ),
                            EUR: appointment.amount,

                        }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("appointments.no_appointments_available")}
                    />
                </Col>
            </Row>
        </Container>
    );

    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default AppointmentCompleted;
